import axios from "axios";
import {
  SET_LOADER,
  SET_LOADER_SECONDARY,
  CLEAR_LOADER,
  GET_OPEN_RESTAURANT_STATUS,
  SET_CURRENT_USER,
  SET_CURRENT_USER_DECODED_TOKEN,
  LOG_OUT,
  SET_RESTAURANT_DETAILS,
  SET_RESTAURANT_SUBSCRIPTION_DETAILS,
  RESTAURANT_CHAIN,
  NOTIFICATION_COUNT,
  CLEAR_ERRORS,
  ADMIN_TO_MERCHANT_REDIRECT,
  SET_MERCHANT_EDIT_INFO,
  SET_DELIVERY_PERSON_DETAILS,
} from "../types";

import { setErrors } from "../actions/errorActions";
import setAuthToken from "../utils/setAuthToken";
import jwt_decode from "jwt-decode";
import { serverApi, PORTAL } from "../../config/Keys";
import Alert from "react-s-alert";
import {
  get_category_menu_setup,
  get_menu_items,
} from "./VendorSubscriptionAction/vendorSubscriptionGetAction";
import store from "../store";

const https = require("https");

const httpsAgent = new https.Agent({
  rejectUnauthorized: false,
  ca: process.env.REACT_APP_SSL_CRT_KEY_FILE,
});

export const create_new_user = (formData, history) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let user_sign_up = await axios.post(`${serverApi}/vendor-user`, formData);
    if (user_sign_up.data) {
      Alert.success("<h4>Register Successfully</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
      let formDataId = {
        vendor_id: user_sign_up.data._id,
      };
      const newFormData = {
        mobile_number: formData.mobile_number,
        country_code: formData.country_code,
        password: formData.password,
        strategy: "phone",
      };
      dispatch(continues_user_login(newFormData, history));
      history.push({
        pathname: "/mapsetup",
      });
      dispatch(create_and_update_restaurant(formDataId));
      // dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};
export const continues_user_login =
  (formData, onCallBack) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let host = window.location.host;
      let { data } = await axios.post(
        `${serverApi}/vendorauthentication`,
        formData,
        {
          httpsAgent,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            portal: host.includes("admin")
              ? "ADMIN"
              : host.includes("merchant")
              ? "MERCHANT"
              : "ANY",
          },
        }
      );
      if (data) {
        // dispatch({ type: CLEAR_LOADER });
        localStorage.clear();
        const userData = data;
        localStorage.setItem("userData", JSON.stringify(userData));
        setAuthToken(userData.accessToken);
        const decoded = jwt_decode(userData.accessToken);
        dispatch(set_current_user(userData));
        dispatch({
          type: SET_CURRENT_USER_DECODED_TOKEN,
          payload: decoded,
        });
        dispatch(create_new_subscription_for_vendor(userData.accessToken));
        let formDataId = {
          vendor_id: userData.VendorUser._id,
        };
        dispatch(get_new_subscription_for_vendor(formDataId));
        // dispatch(create_and_update_restaurant(formDataId));
        onCallBack(userData.accessToken);
        // dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const create_and_update_restaurant =
  (formData, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let add_restaurant_data = await axios.post(
        `${serverApi}/restaurant`,
        formData
      );
      if (add_restaurant_data.status === 201) {
        dispatch({
          type: SET_RESTAURANT_DETAILS,
          payload: add_restaurant_data.data.restaurant._id
            ? add_restaurant_data.data.restaurant
            : add_restaurant_data.data.restaurant[0],
        });
        dispatch({
          type: RESTAURANT_CHAIN,
          payload: add_restaurant_data.data.restaurantchain,
        });
        onSuccess(
          add_restaurant_data.data.restaurant._id
            ? add_restaurant_data.data.restaurant
            : add_restaurant_data.data.restaurant[0]
        );
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      if (onError) {
        onError(err);
      }
    }
  };

export const update_restaurant_pos_restId =
  (id, formData, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let response = await axios.patch(
        `${serverApi}/restaurant/${id}?updateType=POS`,
        formData
      );
      if (response.status === 200) {
        if (onSuccess) onSuccess();

        dispatch({
          type: SET_RESTAURANT_DETAILS,
          payload: response.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      // dispatch(setErrors(err));
      if (onError) {
        onError(err);
      }
    }
  };

export const vendo_session_settings =
  (token, actionBy, role, vendor_id) => async (dispatch) => {
    try {
      let set_restaurant_data = await axios.get(
        `${serverApi}/restaurantopen/${actionBy}?actionBy=${role}&vendor_id=${vendor_id}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (set_restaurant_data.status === 201) {
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const create_new_subscription_for_vendor =
  (token) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let add_new_subscription_record = await axios.post(
        `${serverApi}/subscription`,
        // formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_new_subscription_record.status === 201) {
        dispatch({
          type: SET_RESTAURANT_SUBSCRIPTION_DETAILS,
          payload: add_new_subscription_record.data,
        });
        // dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_new_subscription_for_vendor =
  (formData, onSuccess) => async (dispatch) => {
    const vendor_id = formData.vendor_id;
    // dispatch({ type: SET_LOADER });
    try {
      let get_new_subscription_record = await axios.get(
        `${serverApi}/subscription/${vendor_id}`
      );
      if (get_new_subscription_record.status === 200) {
        dispatch({
          type: SET_RESTAURANT_SUBSCRIPTION_DETAILS,
          payload: get_new_subscription_record.data[0],
        });
        onSuccess(get_new_subscription_record.data[0]);
        // dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const razor_create_fund_account_event =
  (formData, token, onSuccessValidateAccount) => async (dispatch) => {
    dispatch({ type: SET_LOADER });

    try {
      let razor_create_fund_account = await axios.post(
        `${serverApi}/razorpay?createFundAccount=true&vendor=true&isEvent=true`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (
        razor_create_fund_account &&
        razor_create_fund_account.data &&
        razor_create_fund_account.data.error
      ) {
        dispatch({ type: CLEAR_LOADER });
        Alert.error(
          `<h4>${razor_create_fund_account.data.error.description}</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      } else {
        onSuccessValidateAccount(razor_create_fund_account.data.id);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

  export const razor_create_fund_account_experience =
  (formData, token, onSuccessValidateAccount) => async (dispatch) => {
    dispatch({ type: SET_LOADER });

    try {
      let razor_create_fund_account = await axios.post(
        `${serverApi}/razorpay?createFundAccount=true&vendor=true&isEvent=true`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (
        razor_create_fund_account &&
        razor_create_fund_account.data &&
        razor_create_fund_account.data.error
      ) {
        dispatch({ type: CLEAR_LOADER });
        Alert.error(
          `<h4>${razor_create_fund_account.data.error.description}</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      } else {
        onSuccessValidateAccount(razor_create_fund_account.data.id);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const razor_create_fund_account =
  (formData, token, onSuccessValidateAccount, onErrorLocal) =>
  async (dispatch) => {
    dispatch({ type: SET_LOADER });

    try {
      let razor_create_fund_account = await axios.post(
        `${serverApi}/razorpay?createFundAccount=true&vendor=true&isEvent=false`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (
        razor_create_fund_account &&
        razor_create_fund_account.data &&
        razor_create_fund_account.data.error
      ) {
        dispatch({ type: CLEAR_LOADER });
        Alert.error(
          `<h4>${razor_create_fund_account.data.error.description}</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
        if (onErrorLocal) {
          onErrorLocal();
        }
      } else {
        onSuccessValidateAccount(razor_create_fund_account.data.id);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      if (onErrorLocal) {
        onErrorLocal();
      }
    }
  };

export const razor_validate_fund_account_event =
  (formData, token, onSuccessSubMerchant) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let razor_validate_fund_account = await axios.post(
        `${serverApi}/razorpay?validateFundAccount=true&vendor=true&isEvent=true`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (razor_validate_fund_account.data) {
        onSuccessSubMerchant(formData.fund_account_id);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

  export const razor_validate_fund_account_experience =
  (formData, token, onSuccessSubMerchant) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let razor_validate_fund_account = await axios.post(
        `${serverApi}/razorpay?validateFundAccount=true&vendor=true&isEvent=true`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (razor_validate_fund_account.data) {
        onSuccessSubMerchant(formData.fund_account_id);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const razor_validate_fund_account =
  (formData, token, onSuccessSubMerchant) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let razor_validate_fund_account = await axios.post(
        `${serverApi}/razorpay?validateFundAccount=true&vendor=true&isEvent=false`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (razor_validate_fund_account.data) {
        onSuccessSubMerchant(formData.fund_account_id);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const razor_create_sub_merchant_account =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let razor_validate_fund_account = await axios.post(
        `${serverApi}/razorpay?createSubMerchant=true&vendor=true&isEvent=false`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (
        razor_validate_fund_account &&
        razor_validate_fund_account.data &&
        razor_validate_fund_account.data.error &&
        razor_validate_fund_account.data.error.description
      ) {
        dispatch({ type: CLEAR_LOADER });
        Alert.error(
          `<h4>${razor_validate_fund_account.data.error.description}</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      } else {
        onSuccess(formData.fundId, razor_validate_fund_account.data.id);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const razor_create_sub_merchant_account_event =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let razor_validate_fund_account = await axios.post(
        `${serverApi}/razorpay?createSubMerchant=true&vendor=true&isEvent=true`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (
        razor_validate_fund_account &&
        razor_validate_fund_account.data &&
        razor_validate_fund_account.data.error &&
        razor_validate_fund_account.data.error.description
      ) {
        dispatch({ type: CLEAR_LOADER });
        Alert.error(
          `<h4>${razor_validate_fund_account.data.error.description}</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      } else {
        onSuccess(formData.fundId, razor_validate_fund_account.data.id);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const update_new_subscription_for_vendor =
  (subscriptionId, formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      if (window.location.pathname.includes("admin")) {
        formData.edit = true;
      }
      let update_new_subscription_record = await axios.put(
        `${serverApi}/subscription/${subscriptionId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (update_new_subscription_record.data) {
        if (window.location.pathname.includes("admin")) {
          dispatch({
            type: SET_MERCHANT_EDIT_INFO,
            payload: update_new_subscription_record.data,
          });
        } else {
          await dispatch({
            type: SET_RESTAURANT_SUBSCRIPTION_DETAILS,
            payload: update_new_subscription_record.data,
          });
        }
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const update_new_subscription_taxes_data =
  (subscriptionId, formData, token, onSuccess, onErrorHandler) =>
  async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let update_new_subscription_record = await axios.put(
        `${serverApi}/subscription/${subscriptionId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (update_new_subscription_record.data) {
        dispatch({
          type: SET_RESTAURANT_SUBSCRIPTION_DETAILS,
          payload: update_new_subscription_record.data,
        });
        onSuccess(update_new_subscription_record.data);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorHandler(err);
    }
  };

export const forgot_sendotp = (formData, history) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let forgot_sendotp = await axios.post(`${serverApi}/send-otp`, formData);
    if (forgot_sendotp.data) {
      Alert.success("<h4>Otp Send Successfully</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      dispatch({ type: CLEAR_LOADER });
      history.push({
        pathname: "/otp",
        state: { formData: formData },
      });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch({ type: CLEAR_ERRORS });
    dispatch(setErrors(err));
  }
};

export const resendOtp = (formData, callback) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let resendOTP = await axios.post(`${serverApi}/send-otp`, formData);
    if (resendOTP.data) {
      Alert.success("<h4>Otp Resend Successfully</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      dispatch({ type: CLEAR_LOADER });
      callback();
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const verify_otp = (formData, history) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let verifyOtp = await axios.post(`${serverApi}/verify-otp`, formData);
    if (verifyOtp.data) {
      dispatch({ type: CLEAR_LOADER });
      Alert.success("<h4>OTP Successfully Verified</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 5000,
        offset: 35,
      });
      dispatch({ type: CLEAR_LOADER });
      const token = verifyOtp.data.token;
      const mobile_number = formData.mobile_number;
      const country_code = formData.country_code;
      const allData = {
        formData: mobile_number,
        country_code: country_code,
        token: token,
      };
      history.push({
        pathname: "/resetpassword",
        state: { formData: allData },
      });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const forgot_new_password =
  (formData, token, history) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let forgot_new_password = await axios.post(
        `${serverApi}/reset-password`,
        formData,
        {
          headers: {
            Authorization: token,
            // Accept: "application/json",
            // "Content-Type": "application/json",
          },
        }
      );
      if (forgot_new_password.data) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success("<h4>Password Reset Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        dispatch({ type: CLEAR_LOADER });
        history.push({
          pathname: "/passwordreset",
        });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const update_vendor_profile =
  (formData, vendor_id, callback) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let update_vendor_profile = await axios.patch(
        `${serverApi}/vendor-user/${vendor_id}`,
        formData
      );
      if (update_vendor_profile.data) {
        dispatch({ type: CLEAR_LOADER });
        callback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const user_login = (formData, onCallBack) => async (dispatch) => {
  dispatch({ type: SET_LOADER });
  try {
    let host = window.location.host;
    let { data } = await axios.post(
      `${serverApi}/vendorauthentication`,
      formData,
      {
        httpsAgent,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          portal: host.includes("admin")
            ? "ADMIN"
            : host.includes("merchant")
            ? "MERCHANT"
            : "ANY",
        },
      }
    );
    if (data) {
      dispatch({ type: CLEAR_LOADER });
      localStorage.clear();
      const userData = data;
      let token = userData.accessToken;
      // SET Data to Local Storage
      localStorage.setItem("userData", JSON.stringify(userData));
      // Set token To Auth Headers
      setAuthToken(userData.accessToken);
      // Decode token to get user data
      const decoded = jwt_decode(userData.accessToken);
      // Set current user
      dispatch(set_current_user(userData));
      dispatch({
        type: SET_CURRENT_USER_DECODED_TOKEN,
        payload: decoded,
      });
      let formData = {
        vendor_id: userData.VendorUser._id,
      };
      dispatch(get_new_subscription_for_vendor(formData));
      dispatch(create_and_update_restaurant(formData));
      // if (host.includes("merchant")) {
      dispatch(getAllDataOnLogin(token));
      // }
      onCallBack(userData.accessToken);
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const admin_login = (formData, onCallBack) => async (dispatch) => {
  dispatch({ type: SET_LOADER });
  try {
    let { data } = await axios.post(`${serverApi}/admin/auth`, formData, {
      httpsAgent,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        portal: "ADMIN",
      },
    });
    if (data) {
      localStorage.clear();
      const userData = data;
      // SET Data to Local Storage
      localStorage.setItem("userData", JSON.stringify(userData));
      // Set token To Auth Headers
      setAuthToken(userData.accessToken);
      // Decode token to get user data
      const decoded = jwt_decode(userData.accessToken);
      // Set current user
      dispatch(set_current_user(userData));
      dispatch({
        type: SET_CURRENT_USER_DECODED_TOKEN,
        payload: decoded,
      });
      let formData = {
        vendor_id: userData.VendorUser._id,
      };
      dispatch(get_new_subscription_for_vendor(formData));
      dispatch(create_and_update_restaurant(formData));
      onCallBack(userData.accessToken);
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const admin_otp = (formData, onCallBack) => async (dispatch) => {
  dispatch({ type: SET_LOADER });
  try {
    let { data } = await axios.get(`${serverApi}/admin/auth`, {
      httpsAgent,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        portal: "ADMIN",
      },
      params: { userId: formData.userId, pwd: formData.password },
    });
    if (data) {
      dispatch({ type: CLEAR_LOADER });
      Alert.success("<h4>OTP Sent to Mobile Number</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      onCallBack();
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    Alert.error("<h4>Error sending the OTP</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    dispatch(setErrors(err));
  }
};

/*****************************
 * @DESC - SET CURRRENT USER
 ****************************/
export const set_current_user = (decoded) => async (dispatch) => {
  dispatch({
    type: SET_CURRENT_USER,
    payload: decoded,
  });
};

/******************************
 * @DESC - LOGOUT USER
 ****************************/
export const logOutUser = () => async (dispatch) => {
  // REMOVE THE TOKEN
  dispatch({ type: CLEAR_ERRORS });
  await localStorage.clear();
  await setAuthToken(false);
  dispatch(set_current_user({}));
  dispatch({ type: LOG_OUT });
};

export const create_restaurant_chains =
  (formData, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let map_details = await axios.post(
        `${serverApi}/restaurantchain`,
        formData
      );
      if (map_details.data) {
        dispatch({ type: CLEAR_LOADER });
        onSuccess(map_details.data);
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onError(err);
    }
  };

export const update_new_subscription_for_vendor_table_management =
  (subscriptionId, formData, token, onSuccess, table, type) =>
  async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let update_new_subscription_record = await axios.put(
        `${serverApi}/subscription/${subscriptionId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (update_new_subscription_record.data) {
        dispatch({
          type: SET_RESTAURANT_SUBSCRIPTION_DETAILS,
          payload: update_new_subscription_record.data,
        });
        onSuccess(table, update_new_subscription_record.data, type);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_all_restaurant_chain = (token) => async (dispatch) => {
  dispatch({ type: SET_LOADER });
  try {
    let get_all_restaurant_chain = await axios.get(
      `${serverApi}/restaurantchain`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (get_all_restaurant_chain.status === 200) {
      dispatch({
        type: RESTAURANT_CHAIN,
        payload: get_all_restaurant_chain.data.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

/**********************************************
 * @DESC GET RESTURANT CURRENT OPENING STATUS
 **********************************************/
export const get_current_restaurant_opening_status =
  (token, onSuccess, onError) => async (dispatch) => {
    try {
      let get_current_restaurant_opening_status = await axios.get(
        `${serverApi}/restaurant-status`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_current_restaurant_opening_status.status === 200) {
        dispatch({
          type: GET_OPEN_RESTAURANT_STATUS,
          payload: get_current_restaurant_opening_status.data,
        });
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      if (err) {
        onError(err);
      }
    }
  };

export const create_and_update_single_restaurant =
  (formData, onSuccess, onError) => async (dispatch) => {
    // dispatch({ type: SET_LOADER });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let add_restaurant_data = await axios.post(
        `${serverApi}/restaurant`,
        formData
      );
      if (add_restaurant_data.status === 201) {
        dispatch({
          type: SET_RESTAURANT_DETAILS,
          payload: add_restaurant_data.data.restaurant._id
            ? add_restaurant_data.data.restaurant
            : add_restaurant_data.data.restaurant[0],
        });
        dispatch({
          type: RESTAURANT_CHAIN,
          payload: add_restaurant_data.data.restaurantchain,
        });
        onSuccess();
        // dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      if (onError) {
        onError(err);
      }
    }
  };

/*********************************
 * @DESC NOTIFICATION COUNT DATA
 *********************************/
export const get_notification_count = (token, actionBy) => async (dispatch) => {
  try {
    let notification_data = await axios.get(`${serverApi}/notifications`, {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
    if (notification_data.status === 200) {
      dispatch({
        type: NOTIFICATION_COUNT,
        payload: notification_data.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    Alert.error(
      `<h4>${
        err?.response?.message ||
        err?.response?.data?.message ||
        "Please enter correct details."
      }</h4>`,
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 5000,
        offset: 35,
      }
    );
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

const getAllDataOnLogin = (token) => async (dispatch) => {
  let state = store.getState();
  if (
    !state?.onboarding?.menuCategory ||
    state?.onboarding?.menuCategory?.length === 0
  )
    dispatch(get_category_menu_setup(token));
  if (
    !state?.onboarding?.all_menu_items ||
    state?.onboarding?.all_menu_items?.length === 0
  )
    dispatch(get_menu_items(token));
};

export const maintain_delivery_people_data = () => 
(formData, token, onSuccess, onErrorHandler) =>
async (dispatch) => {
  dispatch({type: SET_LOADER });
  try {
    let delivery_persons_data = await axios.get(
      `${serverApi}/user/delivery-persons/65b1417042e7cb5648d8aa40`,
      formData,
      {
        headers:{
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (delivery_persons_data.data) {
      dispatch({
        type : SET_DELIVERY_PERSON_DETAILS,
        payload: delivery_persons_data,
      });
    
    onSuccess(delivery_persons_data.data);
    dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
    onErrorHandler(err);
  }
};